import React, { type FC } from 'react';

export const ProgressBar: FC<{
  text?: string;
  progress?: string;
}> = ({ text, progress }) => {
  if (!text) {
    return;
  }
  return (
    <div className="relative flex h-8 min-h-8 items-center justify-center gap-x-2 overflow-hidden bg-highlight-base px-2 dark:bg-highlight-dark">
      {progress && (
        <div
          className="absolute inset-y-0 left-0 bg-status-success transition-[width] duration-500 ease-in-out"
          style={{ width: `${progress}%` }}
        />
      )}

      <div className="relative z-10 text-xs text-white">{text}</div>
    </div>
  );
};
